/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react/lib/Button';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../utilities/Utils';

export const getColorButtonStyles = (theme: ITheme, bgColor: string): IButtonStyles => {
    const isRtl = getHTMLDir(getAppHost().getLocaleName()) === 'rtl';
    return {
        root: {
            marginRight: isRtl ? 0 : '1rem',
            marginLeft: isRtl ? '1rem' : 0,
            background: bgColor + ' !important',
            selectors: {
                '&.colorTile': {
                    color: theme.palette.white + ' !important',
                },
            },
        },
    };
};

export const getIconButtonStyles = (theme: ITheme, bgColor: string): IButtonStyles => {
    return {
        root: {
            selectors: {
                '&.colorTile': {
                    color: theme.palette.neutralSecondary,
                    fontWeight: FontWeights.regular,
                    selectors: {
                        '&.is-checked.color-selected': {
                            background: bgColor,
                            color: theme.palette.white,
                        },
                    },
                },
            },
        },
        rootHovered: {
            color: theme.palette.themePrimary,
        },
    };
};
